"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _Account = _interopRequireDefault(require("../model/Account"));
var _CommunicationPreferences = _interopRequireDefault(require("../model/CommunicationPreferences"));
var _Customer = _interopRequireDefault(require("../model/Customer"));
var _Device = _interopRequireDefault(require("../model/Device"));
var _GlobalPreferences = _interopRequireDefault(require("../model/GlobalPreferences"));
var _Message = _interopRequireDefault(require("../model/Message"));
var _PaymentPreferences = _interopRequireDefault(require("../model/PaymentPreferences"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
* Customer service.
* @module api/CustomerApi
* @version 3.0
*/
var CustomerApi = exports["default"] = /*#__PURE__*/function () {
  /**
  * Constructs a new CustomerApi. 
  * @alias module:api/CustomerApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function CustomerApi(apiClient) {
    _classCallCheck(this, CustomerApi);
    this.apiClient = apiClient || _ApiClient["default"].instance;
  }

  /**
   * Create Communication Preference
   * Creates a new Communication Preference for the Customer.<br>Use PUT to update/modify the Communication Preference with the details.<br>
   * @param {Number} customerId Customer ID
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/CommunicationPreferences} and HTTP response
   */
  return _createClass(CustomerApi, [{
    key: "createCommunicationPreferenceWithHttpInfo",
    value: function createCommunicationPreferenceWithHttpInfo(customerId) {
      var postBody = null;
      // verify the required parameter 'customerId' is set
      if (customerId === undefined || customerId === null) {
        throw new Error("Missing the required parameter 'customerId' when calling createCommunicationPreference");
      }
      var pathParams = {
        'customerId': customerId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _CommunicationPreferences["default"];
      return this.apiClient.callApi('/customers/{customerId}/communicationpreferences', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Create Communication Preference
     * Creates a new Communication Preference for the Customer.<br>Use PUT to update/modify the Communication Preference with the details.<br>
     * @param {Number} customerId Customer ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/CommunicationPreferences}
     */
  }, {
    key: "createCommunicationPreference",
    value: function createCommunicationPreference(customerId) {
      return this.createCommunicationPreferenceWithHttpInfo(customerId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Create Device
     * Creates a Device for the Customer.<br>The Device holds the Device ID for sending out Push Notifications.<br>Use PUT method to update/modify the Device.
     * @param {Number} customerId Customer ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Device} and HTTP response
     */
  }, {
    key: "createDeviceWithHttpInfo",
    value: function createDeviceWithHttpInfo(customerId) {
      var postBody = null;
      // verify the required parameter 'customerId' is set
      if (customerId === undefined || customerId === null) {
        throw new Error("Missing the required parameter 'customerId' when calling createDevice");
      }
      var pathParams = {
        'customerId': customerId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _Device["default"];
      return this.apiClient.callApi('/customers/{customerId}/devices', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Create Device
     * Creates a Device for the Customer.<br>The Device holds the Device ID for sending out Push Notifications.<br>Use PUT method to update/modify the Device.
     * @param {Number} customerId Customer ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Device}
     */
  }, {
    key: "createDevice",
    value: function createDevice(customerId) {
      return this.createDeviceWithHttpInfo(customerId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Create a Global Preference
     * Creates a Global Preference for the Customer. Use the PUT method to update/modify the Preference. 
     * @param {Number} customerId Customer ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/GlobalPreferences} and HTTP response
     */
  }, {
    key: "createGlobalPreferenceWithHttpInfo",
    value: function createGlobalPreferenceWithHttpInfo(customerId) {
      var postBody = null;
      // verify the required parameter 'customerId' is set
      if (customerId === undefined || customerId === null) {
        throw new Error("Missing the required parameter 'customerId' when calling createGlobalPreference");
      }
      var pathParams = {
        'customerId': customerId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _GlobalPreferences["default"];
      return this.apiClient.callApi('/customers/{customerId}/globalpreferences', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Create a Global Preference
     * Creates a Global Preference for the Customer. Use the PUT method to update/modify the Preference. 
     * @param {Number} customerId Customer ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/GlobalPreferences}
     */
  }, {
    key: "createGlobalPreference",
    value: function createGlobalPreference(customerId) {
      return this.createGlobalPreferenceWithHttpInfo(customerId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Create a Payment Preference
     * Creates a Payment Preference for the Customer.<br>Payment Preferences can be used to hold details of a saved payment method – for example a Credit Card token.<br>Use the PUT method to update/modify.<br>
     * @param {Number} customerId Customer ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/PaymentPreferences} and HTTP response
     */
  }, {
    key: "createPaymentPreferenceWithHttpInfo",
    value: function createPaymentPreferenceWithHttpInfo(customerId) {
      var postBody = null;
      // verify the required parameter 'customerId' is set
      if (customerId === undefined || customerId === null) {
        throw new Error("Missing the required parameter 'customerId' when calling createPaymentPreference");
      }
      var pathParams = {
        'customerId': customerId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _PaymentPreferences["default"];
      return this.apiClient.callApi('/customers/{customerId}/paymentpreferences', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Create a Payment Preference
     * Creates a Payment Preference for the Customer.<br>Payment Preferences can be used to hold details of a saved payment method – for example a Credit Card token.<br>Use the PUT method to update/modify.<br>
     * @param {Number} customerId Customer ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/PaymentPreferences}
     */
  }, {
    key: "createPaymentPreference",
    value: function createPaymentPreference(customerId) {
      return this.createPaymentPreferenceWithHttpInfo(customerId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * List a Customer's Accounts
     * Get a list of Accounts for the given Customer.<br>The list can be filtered according to Account Type.<br>
     * @param {Number} customerId Customer ID
     * @param {Object} opts Optional parameters
     * @param {String} [filter] Filter
     * @param {String} [accountType] AccountType
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/Account>} and HTTP response
     */
  }, {
    key: "getAccountsWithHttpInfo",
    value: function getAccountsWithHttpInfo(customerId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'customerId' is set
      if (customerId === undefined || customerId === null) {
        throw new Error("Missing the required parameter 'customerId' when calling getAccounts");
      }
      var pathParams = {
        'customerId': customerId
      };
      var queryParams = {
        'filter': opts['filter'],
        'accountType': opts['accountType']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_Account["default"]];
      return this.apiClient.callApi('/customers/{customerId}/accounts', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * List a Customer's Accounts
     * Get a list of Accounts for the given Customer.<br>The list can be filtered according to Account Type.<br>
     * @param {Number} customerId Customer ID
     * @param {Object} opts Optional parameters
     * @param {String} opts.filter Filter
     * @param {String} opts.accountType AccountType
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/Account>}
     */
  }, {
    key: "getAccounts",
    value: function getAccounts(customerId, opts) {
      return this.getAccountsWithHttpInfo(customerId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Get Communication Preference
     * Get a specific Communication Preference. This will return the details of the communication preference for the Customer.<br>The Communication Preferences hold how the Customer has agreed to be communicated with (e-mail/SMS/push notification). The detail will return the actual mobile number or email address for the preference.<br>The data can then be updated using the PUT method.<br>
     * @param {Number} customerId Customer ID
     * @param {Number} communicationpreferenceId Communication Preferences ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/CommunicationPreferences} and HTTP response
     */
  }, {
    key: "getCommunicationPreferenceWithHttpInfo",
    value: function getCommunicationPreferenceWithHttpInfo(customerId, communicationpreferenceId) {
      var postBody = null;
      // verify the required parameter 'customerId' is set
      if (customerId === undefined || customerId === null) {
        throw new Error("Missing the required parameter 'customerId' when calling getCommunicationPreference");
      }
      // verify the required parameter 'communicationpreferenceId' is set
      if (communicationpreferenceId === undefined || communicationpreferenceId === null) {
        throw new Error("Missing the required parameter 'communicationpreferenceId' when calling getCommunicationPreference");
      }
      var pathParams = {
        'customerId': customerId,
        'communicationpreferenceId': communicationpreferenceId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _CommunicationPreferences["default"];
      return this.apiClient.callApi('/customers/{customerId}/communicationpreferences/{communicationpreferenceId}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Get Communication Preference
     * Get a specific Communication Preference. This will return the details of the communication preference for the Customer.<br>The Communication Preferences hold how the Customer has agreed to be communicated with (e-mail/SMS/push notification). The detail will return the actual mobile number or email address for the preference.<br>The data can then be updated using the PUT method.<br>
     * @param {Number} customerId Customer ID
     * @param {Number} communicationpreferenceId Communication Preferences ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/CommunicationPreferences}
     */
  }, {
    key: "getCommunicationPreference",
    value: function getCommunicationPreference(customerId, communicationpreferenceId) {
      return this.getCommunicationPreferenceWithHttpInfo(customerId, communicationpreferenceId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Get all Communication Preferences.
     * Get a list of all Communication Preferences for this Customer.<br>The Communication Preferences hold how the Customer has agreed to be communicated with (e-mail/SMS/push notification).<br>A list of HATEOAS links is returned enabling drill down for more information.<br>
     * @param {Number} customerId Customer ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/CommunicationPreferences>} and HTTP response
     */
  }, {
    key: "getCommunicationPreferencesWithHttpInfo",
    value: function getCommunicationPreferencesWithHttpInfo(customerId) {
      var postBody = null;
      // verify the required parameter 'customerId' is set
      if (customerId === undefined || customerId === null) {
        throw new Error("Missing the required parameter 'customerId' when calling getCommunicationPreferences");
      }
      var pathParams = {
        'customerId': customerId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_CommunicationPreferences["default"]];
      return this.apiClient.callApi('/customers/{customerId}/communicationpreferences', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Get all Communication Preferences.
     * Get a list of all Communication Preferences for this Customer.<br>The Communication Preferences hold how the Customer has agreed to be communicated with (e-mail/SMS/push notification).<br>A list of HATEOAS links is returned enabling drill down for more information.<br>
     * @param {Number} customerId Customer ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/CommunicationPreferences>}
     */
  }, {
    key: "getCommunicationPreferences",
    value: function getCommunicationPreferences(customerId) {
      return this.getCommunicationPreferencesWithHttpInfo(customerId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Get Customer
     * Gets a specific Customer and their details using the Customer ID.
     * @param {Number} customerId Customer ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Customer} and HTTP response
     */
  }, {
    key: "getCustomerWithHttpInfo",
    value: function getCustomerWithHttpInfo(customerId) {
      var postBody = null;
      // verify the required parameter 'customerId' is set
      if (customerId === undefined || customerId === null) {
        throw new Error("Missing the required parameter 'customerId' when calling getCustomer");
      }
      var pathParams = {
        'customerId': customerId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _Customer["default"];
      return this.apiClient.callApi('/customers/{customerId}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Get Customer
     * Gets a specific Customer and their details using the Customer ID.
     * @param {Number} customerId Customer ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Customer}
     */
  }, {
    key: "getCustomer",
    value: function getCustomer(customerId) {
      return this.getCustomerWithHttpInfo(customerId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Get a specific Device.
     * Gets a specific Device on a Customer.<br>This will return the details of a particular Device.<br>The Device holds the Device ID for sending out Push Notifications.<br>The data can then be updated with a PUT.
     * @param {Number} customerId Customer ID
     * @param {Number} deviceId Device ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Device} and HTTP response
     */
  }, {
    key: "getDeviceWithHttpInfo",
    value: function getDeviceWithHttpInfo(customerId, deviceId) {
      var postBody = null;
      // verify the required parameter 'customerId' is set
      if (customerId === undefined || customerId === null) {
        throw new Error("Missing the required parameter 'customerId' when calling getDevice");
      }
      // verify the required parameter 'deviceId' is set
      if (deviceId === undefined || deviceId === null) {
        throw new Error("Missing the required parameter 'deviceId' when calling getDevice");
      }
      var pathParams = {
        'customerId': customerId,
        'deviceId': deviceId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _Device["default"];
      return this.apiClient.callApi('/customers/{customerId}/devices/{deviceId}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Get a specific Device.
     * Gets a specific Device on a Customer.<br>This will return the details of a particular Device.<br>The Device holds the Device ID for sending out Push Notifications.<br>The data can then be updated with a PUT.
     * @param {Number} customerId Customer ID
     * @param {Number} deviceId Device ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Device}
     */
  }, {
    key: "getDevice",
    value: function getDevice(customerId, deviceId) {
      return this.getDeviceWithHttpInfo(customerId, deviceId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * List Devices
     * Get a list of Devices for the given Customer.<br>The Device holds the Device ID, which is used for sending out Push Notifications.<br>A list of HATEOAS links is also returned to view the specific Devices in more detail.
     * @param {Number} customerId Customer ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/Device>} and HTTP response
     */
  }, {
    key: "getDevicesWithHttpInfo",
    value: function getDevicesWithHttpInfo(customerId) {
      var postBody = null;
      // verify the required parameter 'customerId' is set
      if (customerId === undefined || customerId === null) {
        throw new Error("Missing the required parameter 'customerId' when calling getDevices");
      }
      var pathParams = {
        'customerId': customerId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_Device["default"]];
      return this.apiClient.callApi('/customers/{customerId}/devices', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * List Devices
     * Get a list of Devices for the given Customer.<br>The Device holds the Device ID, which is used for sending out Push Notifications.<br>A list of HATEOAS links is also returned to view the specific Devices in more detail.
     * @param {Number} customerId Customer ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/Device>}
     */
  }, {
    key: "getDevices",
    value: function getDevices(customerId) {
      return this.getDevicesWithHttpInfo(customerId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Get a specific Global Preferences.
     * Get a specific Global Preference for the Customer.  This will return the details of the Global Preference. The data can then be used to update data. 
     * @param {Number} customerId Customer ID
     * @param {Number} globalpreferenceId Global Preferences ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/GlobalPreferences} and HTTP response
     */
  }, {
    key: "getGlobalPreferenceWithHttpInfo",
    value: function getGlobalPreferenceWithHttpInfo(customerId, globalpreferenceId) {
      var postBody = null;
      // verify the required parameter 'customerId' is set
      if (customerId === undefined || customerId === null) {
        throw new Error("Missing the required parameter 'customerId' when calling getGlobalPreference");
      }
      // verify the required parameter 'globalpreferenceId' is set
      if (globalpreferenceId === undefined || globalpreferenceId === null) {
        throw new Error("Missing the required parameter 'globalpreferenceId' when calling getGlobalPreference");
      }
      var pathParams = {
        'customerId': customerId,
        'globalpreferenceId': globalpreferenceId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _GlobalPreferences["default"];
      return this.apiClient.callApi('/customers/{customerId}/globalpreferences/{globalpreferenceId}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Get a specific Global Preferences.
     * Get a specific Global Preference for the Customer.  This will return the details of the Global Preference. The data can then be used to update data. 
     * @param {Number} customerId Customer ID
     * @param {Number} globalpreferenceId Global Preferences ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/GlobalPreferences}
     */
  }, {
    key: "getGlobalPreference",
    value: function getGlobalPreference(customerId, globalpreferenceId) {
      return this.getGlobalPreferenceWithHttpInfo(customerId, globalpreferenceId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Get all Global Preferences
     * Get all Global preferences for the Customer. This returns a list of HATEOAS links enabling drill down for more detail. 
     * @param {Number} customerId Customer ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/GlobalPreferences>} and HTTP response
     */
  }, {
    key: "getGlobalPreferencesWithHttpInfo",
    value: function getGlobalPreferencesWithHttpInfo(customerId) {
      var postBody = null;
      // verify the required parameter 'customerId' is set
      if (customerId === undefined || customerId === null) {
        throw new Error("Missing the required parameter 'customerId' when calling getGlobalPreferences");
      }
      var pathParams = {
        'customerId': customerId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_GlobalPreferences["default"]];
      return this.apiClient.callApi('/customers/{customerId}/globalpreferences', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Get all Global Preferences
     * Get all Global preferences for the Customer. This returns a list of HATEOAS links enabling drill down for more detail. 
     * @param {Number} customerId Customer ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/GlobalPreferences>}
     */
  }, {
    key: "getGlobalPreferences",
    value: function getGlobalPreferences(customerId) {
      return this.getGlobalPreferencesWithHttpInfo(customerId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Get a specific Payment Preference.
     * Get a specific Payment Preference for the Customer. <br>This will return the details of the Payment Preference.<br>Payment Preferences can be used to hold details of a saved payment method – for example a Credit Card token.<br>The data can then be used to update data.<br>
     * @param {Number} customerId Customer ID
     * @param {Number} paymentpreferenceId Payment Preferences ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/PaymentPreferences} and HTTP response
     */
  }, {
    key: "getPaymentPreferenceWithHttpInfo",
    value: function getPaymentPreferenceWithHttpInfo(customerId, paymentpreferenceId) {
      var postBody = null;
      // verify the required parameter 'customerId' is set
      if (customerId === undefined || customerId === null) {
        throw new Error("Missing the required parameter 'customerId' when calling getPaymentPreference");
      }
      // verify the required parameter 'paymentpreferenceId' is set
      if (paymentpreferenceId === undefined || paymentpreferenceId === null) {
        throw new Error("Missing the required parameter 'paymentpreferenceId' when calling getPaymentPreference");
      }
      var pathParams = {
        'customerId': customerId,
        'paymentpreferenceId': paymentpreferenceId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _PaymentPreferences["default"];
      return this.apiClient.callApi('/customers/{customerId}/paymentpreferences/{paymentpreferenceId}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Get a specific Payment Preference.
     * Get a specific Payment Preference for the Customer. <br>This will return the details of the Payment Preference.<br>Payment Preferences can be used to hold details of a saved payment method – for example a Credit Card token.<br>The data can then be used to update data.<br>
     * @param {Number} customerId Customer ID
     * @param {Number} paymentpreferenceId Payment Preferences ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/PaymentPreferences}
     */
  }, {
    key: "getPaymentPreference",
    value: function getPaymentPreference(customerId, paymentpreferenceId) {
      return this.getPaymentPreferenceWithHttpInfo(customerId, paymentpreferenceId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Get all Payment Preferences
     * Get all Payment Preferences for the Customer.<br>Payment Preferences can be used to hold details of a saved payment method – for example a Credit Card token.<br>A list of HATEOAS links is returned enabling drill down for more detail.<br>
     * @param {Number} customerId Customer ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/PaymentPreferences>} and HTTP response
     */
  }, {
    key: "getPaymentPreferencesWithHttpInfo",
    value: function getPaymentPreferencesWithHttpInfo(customerId) {
      var postBody = null;
      // verify the required parameter 'customerId' is set
      if (customerId === undefined || customerId === null) {
        throw new Error("Missing the required parameter 'customerId' when calling getPaymentPreferences");
      }
      var pathParams = {
        'customerId': customerId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = [];
      var accepts = ['application/xml', 'application/json'];
      var returnType = [_PaymentPreferences["default"]];
      return this.apiClient.callApi('/customers/{customerId}/paymentpreferences', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Get all Payment Preferences
     * Get all Payment Preferences for the Customer.<br>Payment Preferences can be used to hold details of a saved payment method – for example a Credit Card token.<br>A list of HATEOAS links is returned enabling drill down for more detail.<br>
     * @param {Number} customerId Customer ID
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/PaymentPreferences>}
     */
  }, {
    key: "getPaymentPreferences",
    value: function getPaymentPreferences(customerId) {
      return this.getPaymentPreferencesWithHttpInfo(customerId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Modify a Communication Preference
     * Modify a Communication Preference. This will modify/update the details of the Communication Preference. Use this method to add the mobile number, email address or other detail to the Communication Preference.
     * @param {Number} customerId Customer ID
     * @param {Number} communicationpreferenceId Communciation Preferences ID
     * @param {module:model/CommunicationPreferences} communicationPreferences Details
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/CommunicationPreferences} and HTTP response
     */
  }, {
    key: "modifyCommunicationPreferenceWithHttpInfo",
    value: function modifyCommunicationPreferenceWithHttpInfo(customerId, communicationpreferenceId, communicationPreferences) {
      var postBody = communicationPreferences;
      // verify the required parameter 'customerId' is set
      if (customerId === undefined || customerId === null) {
        throw new Error("Missing the required parameter 'customerId' when calling modifyCommunicationPreference");
      }
      // verify the required parameter 'communicationpreferenceId' is set
      if (communicationpreferenceId === undefined || communicationpreferenceId === null) {
        throw new Error("Missing the required parameter 'communicationpreferenceId' when calling modifyCommunicationPreference");
      }
      // verify the required parameter 'communicationPreferences' is set
      if (communicationPreferences === undefined || communicationPreferences === null) {
        throw new Error("Missing the required parameter 'communicationPreferences' when calling modifyCommunicationPreference");
      }
      var pathParams = {
        'customerId': customerId,
        'communicationpreferenceId': communicationpreferenceId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = ['application/json', 'application/xml'];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _CommunicationPreferences["default"];
      return this.apiClient.callApi('/customers/{customerId}/communicationpreferences/{communicationpreferenceId}', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Modify a Communication Preference
     * Modify a Communication Preference. This will modify/update the details of the Communication Preference. Use this method to add the mobile number, email address or other detail to the Communication Preference.
     * @param {Number} customerId Customer ID
     * @param {Number} communicationpreferenceId Communciation Preferences ID
     * @param {module:model/CommunicationPreferences} communicationPreferences Details
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/CommunicationPreferences}
     */
  }, {
    key: "modifyCommunicationPreference",
    value: function modifyCommunicationPreference(customerId, communicationpreferenceId, communicationPreferences) {
      return this.modifyCommunicationPreferenceWithHttpInfo(customerId, communicationpreferenceId, communicationPreferences).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Modify Device.
     * Modify a device.Modify a Device for the Customer.<br>This will modify/update the details of a particular Device.<br>The Device holds the Device ID for sending out Push Notifications, which is in the registration ID field.<br>The details must be the body of the request.
     * @param {Number} customerId Customer ID
     * @param {Number} deviceId Device ID
     * @param {module:model/Device} device Device details
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/Device} and HTTP response
     */
  }, {
    key: "modifyDeviceWithHttpInfo",
    value: function modifyDeviceWithHttpInfo(customerId, deviceId, device) {
      var postBody = device;
      // verify the required parameter 'customerId' is set
      if (customerId === undefined || customerId === null) {
        throw new Error("Missing the required parameter 'customerId' when calling modifyDevice");
      }
      // verify the required parameter 'deviceId' is set
      if (deviceId === undefined || deviceId === null) {
        throw new Error("Missing the required parameter 'deviceId' when calling modifyDevice");
      }
      // verify the required parameter 'device' is set
      if (device === undefined || device === null) {
        throw new Error("Missing the required parameter 'device' when calling modifyDevice");
      }
      var pathParams = {
        'customerId': customerId,
        'deviceId': deviceId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = ['application/json', 'application/xml'];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _Device["default"];
      return this.apiClient.callApi('/customers/{customerId}/devices/{deviceId}', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Modify Device.
     * Modify a device.Modify a Device for the Customer.<br>This will modify/update the details of a particular Device.<br>The Device holds the Device ID for sending out Push Notifications, which is in the registration ID field.<br>The details must be the body of the request.
     * @param {Number} customerId Customer ID
     * @param {Number} deviceId Device ID
     * @param {module:model/Device} device Device details
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/Device}
     */
  }, {
    key: "modifyDevice",
    value: function modifyDevice(customerId, deviceId, device) {
      return this.modifyDeviceWithHttpInfo(customerId, deviceId, device).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Modify a Global Preferences.
     * Modify a Global Preference for a Customer.  This will modify/update the details the Global Preference. 
     * @param {Number} customerId Customer ID
     * @param {Number} globalpreferenceId Global Preferences ID
     * @param {module:model/GlobalPreferences} globalPreferences Details
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/GlobalPreferences} and HTTP response
     */
  }, {
    key: "modifyGlobalPreferenceWithHttpInfo",
    value: function modifyGlobalPreferenceWithHttpInfo(customerId, globalpreferenceId, globalPreferences) {
      var postBody = globalPreferences;
      // verify the required parameter 'customerId' is set
      if (customerId === undefined || customerId === null) {
        throw new Error("Missing the required parameter 'customerId' when calling modifyGlobalPreference");
      }
      // verify the required parameter 'globalpreferenceId' is set
      if (globalpreferenceId === undefined || globalpreferenceId === null) {
        throw new Error("Missing the required parameter 'globalpreferenceId' when calling modifyGlobalPreference");
      }
      // verify the required parameter 'globalPreferences' is set
      if (globalPreferences === undefined || globalPreferences === null) {
        throw new Error("Missing the required parameter 'globalPreferences' when calling modifyGlobalPreference");
      }
      var pathParams = {
        'customerId': customerId,
        'globalpreferenceId': globalpreferenceId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = ['application/json', 'application/xml'];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _GlobalPreferences["default"];
      return this.apiClient.callApi('/customers/{customerId}/globalpreferences/{globalpreferenceId}', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Modify a Global Preferences.
     * Modify a Global Preference for a Customer.  This will modify/update the details the Global Preference. 
     * @param {Number} customerId Customer ID
     * @param {Number} globalpreferenceId Global Preferences ID
     * @param {module:model/GlobalPreferences} globalPreferences Details
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/GlobalPreferences}
     */
  }, {
    key: "modifyGlobalPreference",
    value: function modifyGlobalPreference(customerId, globalpreferenceId, globalPreferences) {
      return this.modifyGlobalPreferenceWithHttpInfo(customerId, globalpreferenceId, globalPreferences).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * Modify a Payment Preference.
     * Modify a Payment Preference for the Customer. <br>Payment Preferences can be used to hold details of a saved payment method – for example a Credit Card token.<br>This will modify/update the details the Payment Preference.<br>
     * @param {Number} customerId Customer ID
     * @param {Number} paymentpreferenceId Payment Preferences ID
     * @param {module:model/PaymentPreferences} paymentPreferences Details
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/PaymentPreferences} and HTTP response
     */
  }, {
    key: "modifyPaymentPreferenceWithHttpInfo",
    value: function modifyPaymentPreferenceWithHttpInfo(customerId, paymentpreferenceId, paymentPreferences) {
      var postBody = paymentPreferences;
      // verify the required parameter 'customerId' is set
      if (customerId === undefined || customerId === null) {
        throw new Error("Missing the required parameter 'customerId' when calling modifyPaymentPreference");
      }
      // verify the required parameter 'paymentpreferenceId' is set
      if (paymentpreferenceId === undefined || paymentpreferenceId === null) {
        throw new Error("Missing the required parameter 'paymentpreferenceId' when calling modifyPaymentPreference");
      }
      // verify the required parameter 'paymentPreferences' is set
      if (paymentPreferences === undefined || paymentPreferences === null) {
        throw new Error("Missing the required parameter 'paymentPreferences' when calling modifyPaymentPreference");
      }
      var pathParams = {
        'customerId': customerId,
        'paymentpreferenceId': paymentpreferenceId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['bearerAuth'];
      var contentTypes = ['application/json', 'application/xml'];
      var accepts = ['application/xml', 'application/json'];
      var returnType = _PaymentPreferences["default"];
      return this.apiClient.callApi('/customers/{customerId}/paymentpreferences/{paymentpreferenceId}', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * Modify a Payment Preference.
     * Modify a Payment Preference for the Customer. <br>Payment Preferences can be used to hold details of a saved payment method – for example a Credit Card token.<br>This will modify/update the details the Payment Preference.<br>
     * @param {Number} customerId Customer ID
     * @param {Number} paymentpreferenceId Payment Preferences ID
     * @param {module:model/PaymentPreferences} paymentPreferences Details
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/PaymentPreferences}
     */
  }, {
    key: "modifyPaymentPreference",
    value: function modifyPaymentPreference(customerId, paymentpreferenceId, paymentPreferences) {
      return this.modifyPaymentPreferenceWithHttpInfo(customerId, paymentpreferenceId, paymentPreferences).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);
}();